const DOXY_URL = process.env.DOXY_URL;
const NEW_VIDEO_BASE_URL = process.env.VIDEO_URL;

/**
 * Returns false when the appointment should not surface a "Join Call" affordance.
 * Currently only "Assessment - In Person" (IN_PERSON_ASSESSMENT) is non-joinable —
 * those appointments happen at the client's home and have no video session to join.
 *
 * Accepts either the `billing_type` field directly (video_calls.billing_type) or
 * an appointment object with `.billing_type`.
 */
export const isJoinable = (appointmentOrBillingType) => {
  if (appointmentOrBillingType == null) return true;
  const billingType =
    typeof appointmentOrBillingType === "string"
      ? appointmentOrBillingType
      : appointmentOrBillingType?.billing_type;
  return billingType !== "IN_PERSON_ASSESSMENT";
};

export const useJoinAppointment = () => {
  const getVideoUrl = (videoKey) => `${NEW_VIDEO_BASE_URL}/video/${videoKey}`;

  const joinAppointment = ({ offPlatform, videoKey }) => {
    if (offPlatform) {
      window.open(DOXY_URL, "_blank");
      return;
    }

    window.location.href = getVideoUrl(videoKey);
  };

  return {
    joinAppointment,
    getVideoUrl,
    // Legacy in-app video has been retired — all calls use the dedicated video service.
    hasNewVideoExp: true,
    isLoading: false,
  };
};
